import { render } from "./index_new.vue?vue&type=template&id=7112426c&scoped=true"
import script from "./index_new.vue?vue&type=script&lang=js"
export * from "./index_new.vue?vue&type=script&lang=js"

import "./index_new.vue?vue&type=style&index=0&id=7112426c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7112426c"]])

export default __exports__